module.exports = __webpack_public_path__ + "media/images/icon__point--lost@2x-f626cd57f8668c09348c79063eb81d05.png";